import React from 'react';
import PropTypes from 'prop-types';
import Section from 'helpers/Section';

const CarsSeo = ({translations: {title, body}}) => (
  <Section
    sectionClass="pt-3 pb-7 text-center bg-white"
  >
    <div className="w-sm-2-3 mx-auto">
      <p className="display-3 font-light">
        {title}
      </p>
      <p>
        {body}  
      </p>
    </div>
  </Section>
);

CarsSeo.propTypes = {
  translations: PropTypes.shape({
    title: PropTypes.string.isRequired,
    body: PropTypes.string.isRequired
  })
};

export default CarsSeo;
